import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-large-message',
  templateUrl: './large-message.component.html',
  styleUrls: ['./large-message.component.scss'],
  standalone: false
})
export class LargeMessageComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data:any,
    public dialogRef: MatDialogRef<LargeMessageComponent>
  ){}

}
